module.exports = __webpack_public_path__ + "img/we-chat.e65851f1.png";